import React, { Suspense, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Router } from 'react-router-dom'
import history from '../../History'
import FloorWardenAcceptor from '../../components/FloorWarden/AcknowledgeForm'
import TeamAssignmentAcceptor from '../../components/Teams/TeamAssignmentAcceptor'
import GuardianLayout from './Layout'
import Loading from '../../components/Loading'
import Routes from './Routes'
import TenantConfig from '../../components/Admin/TenantConfigurator'
import UserConfig from '../../components/UserConfigurator'
import TermsOfUseAcceptance from '../../components/TermsOfUseAcceptance'
import './styles.css'
import { useShowTenantConfigurator } from '../../components/Admin/Hooks/useShowTenantConfigurator'
import useInit from '../../hooks/useInit'


function Guardian() {
    const { isAcknowledged, population, loading, refresh } = useShowTenantConfigurator()
    // First-login popup order: Confirm User Information → Terms of Use (when
    // enabled) → team Accept/Decline → Tenant Activation Policy → Estimated
    // Population. termsOfUseVisible / teamAcceptorVisible are the windows'
    // "blocking" signals (pending or on screen), not merely visibility.
    const [termsOfUseVisible, setTermsOfUseVisible] = useState(false)
    const [teamAcceptorVisible, setTeamAcceptorVisible] = useState(false)
    const [showTenantConfig, setShowTenantConfig] = useState(false)
    const [userConfigVisible, setUserConfigVisible] = useState(false)
    const roles = useSelector((state) => state.app.user.roles)
    const adminMode = useSelector((state) => state.app.adminMode)
    const user = useSelector((state) => state.app.user)
    const isTenantAdmin = roles?.includes('TENANT_ADMIN')

    useInit()



    // Note: Removed automatic logout check for declined acknowledgments
    // Users who decline should be able to log back in and see the policy again
    // unless another tenant admin has accepted it since their decline

    // Check if the user is an admin for highlighting admin menu
    useEffect(() => {
        const isAdmin = roles.some(role =>
            role === 'PROPERTY_ADMIN' ||
            role === 'BUILDING_ADMIN' ||
            role === 'TENANT_ADMIN' ||
            role === 'SUPER_ADMIN'
        )

        // If they're an admin and we're on the root path, we want to ensure
        // the admin menu is highlighted even if they don't get redirected
        if (isAdmin && history.location.pathname === '/') {
            // This doesn't actually change the URL but will force a re-render
            // with the same path, which will trigger our useEffect in SideMenu
            history.replace('/')
        }
    }, [roles])

    document.title = 'BSS Guardian'

    // Track when TenantConfig becomes visible/hidden
    const handleTenantConfigVisibility = (isVisible) => {
        setShowTenantConfig(isVisible);
    }

    return (
        <Router history={history}>
            <GuardianLayout>
                <FloorWardenAcceptor />
                <TeamAssignmentAcceptor
                    hideForUserConfig={userConfigVisible}
                    hideForTerms={termsOfUseVisible}
                    onVisibilityChange={setTeamAcceptorVisible}
                />
                <TenantConfig
                    loading={loading}
                    acknowledgement={isAcknowledged}
                    population={population}
                    onRefresh={refresh}
                    hideForTerms={termsOfUseVisible}
                    hideForUserConfig={userConfigVisible}
                    hideForTeams={teamAcceptorVisible}
                    onVisibilityChange={handleTenantConfigVisibility}
                />
                <TermsOfUseAcceptance
                    onVisibilityChange={setTermsOfUseVisible}
                    hideForUserConfig={userConfigVisible}
                />
                <UserConfig
                    onVisibilityChange={setUserConfigVisible}
                />
                <Suspense fallback={<Loading />}>
                    <Routes />
                </Suspense>
            </GuardianLayout>
        </Router>
    )
}

export default Guardian